export function groupByItemType(items = []) {
  if (!items?.length) return {}
  const ApprovalItems = items?.map(approval => ({
    ...approval,
    checked:
      (approval?.approval_status == 'pending' || approval?.approval_status == 'rejected') &&
        approval?.item_category === 'insurance' && approval?.is_approval
        ? false
        : true,
  }))
  const filteredItems = ApprovalItems.filter(
    item =>
      !(
        item?.selected_category === 'medication-codes' &&
        item?.internal_pharmacy === false
      )
  )

  return Object?.groupBy(
    filteredItems,
    item => item?.selected_category || item?.item_type
  )
}

export function getGroupItemFirst(billingVisitData, index = 0, type = 'cash') {
  const items =
    billingVisitData?.items?.filter(
      item => item?.status?.toLowerCase() === 'unpaid'
    ) || []

  const groupedItems = groupByItemType(items)

  const currentGroup = Object?.values(groupedItems)?.[index] || []

  const hasCash = currentGroup.some(item => item?.item_category === 'cash')
  const hasInsurance = currentGroup.some(item => item?.item_category != 'cash')
  return currentGroup.filter(item => {
    if (hasCash && hasInsurance) {
      return item?.item_category === type
    } else if (hasCash) {
      return item?.item_category === 'cash'
    } else if (hasInsurance) {
      return item?.item_category != 'cash'
    }
    return false
  })
}

export function flattenReports(data) {
  return data?.flatMap(group =>
    group?.reports?.map(report => ({
      ...report,
      payment_method: group?._id?.payment_method,
    }))
  )
}

export function flattenAndGroupReportsByUserId(data) {
  const flatReports = data?.flatMap(group =>
    group?.reports?.map(report => ({
      ...report,
      paymentMethod: group?._id?.payment_method,
    }))
  )

  const grouped = {}
  flatReports?.forEach(report => {
    const key = report?.created_by?.user_id || 'Unknown'
    if (!grouped[key]) grouped[key] = []
    grouped[key].push(report)
  })
  const result = []
  Object.entries(grouped)?.forEach(([userId, reports]) => {
    result.push({
      userName: reports?.[0]?.created_by?.name,
      isGroupHeader: true,
    })
    result.push(...reports)
    const totalAmount = reports?.reduce(
      (sum, r) => sum + (r.sale_amount || 0),
      0
    )
    const totalCash = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'cash')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)
    const totalCard = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'card')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)
    const totalMultiPayment = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'multi_payment')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)
    const totalDeposit = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'deposit')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)

    result.push({
      separator: true,
      user_id: userId,
      total_amount: totalAmount,
      total_cash: totalCash,
      total_card: totalCard,
      total_multi_payment: totalMultiPayment,
      total_deposit: totalDeposit,
    })
  })

  return result
}

export function reduceReportsByReceptionist(data) {
  const flatReports = data?.flatMap(group =>
    group?.reports?.map(report => ({
      ...report,
      paymentMethod: group?._id?.payment_method,
    }))
  )

  const grouped = {}
  flatReports?.forEach(report => {
    const key = report?.created_by?.user_id || 'Unknown'
    if (!grouped[key]) grouped[key] = []
    grouped[key].push(report)
  })

  const result = []
  let grand_total_amount = 0
  Object.entries(grouped)?.forEach(([userId, reports]) => {
    const totalAmount = reports?.reduce(
      (sum, r) => sum + (r.sale_amount || 0),
      0
    )
    const totalCash = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'cash')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)
    const totalCard = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'card')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)
    const totalMultiPayment = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'multi_payment')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)
    const totalDeposit = reports
      .filter(rp => rp.paymentMethod?.toLowerCase() === 'deposit')
      .reduce((sum, r) => sum + (r.sale_amount || 0), 0)

    grand_total_amount += totalAmount
    result.push({
      isGroupHeader: false,
      separator: true,
      user_id: userId,
      userName: reports?.[0]?.created_by?.name,
      total_amount: totalAmount,
      total_cash: totalCash,
      total_card: totalCard,
      total_multi_payment: totalMultiPayment,
      total_deposit: totalDeposit,
    })
  })

  return { result, grand_total_amount }
}

export function flattenFinancialReports(data) {
  const flatReports = data?.flatMap(group =>
    group?.reports?.map(report => ({
      ...report,
      invoice_number: report?.cash_invoice_number,
      total_vat:
        (report?.patient_vat + report?.company_vat)?.toFixed(2) || '0.00',
      total_gross_amount:
        report?.total_gross_amount
          // + report?.total_discount +
          // report?.patient_vat +
          // report?.company_vat +
          // report?.total_discount
          ?.toFixed(2) || '0.00',
      total_discount: report?.total_discount?.toFixed(2) || '0.00',
      total_amount_w_vat: (report?.total_amount || report?.net_with_vat || (parseFloat(report?.total_gross_amount || 0) - parseFloat(report?.total_discount || 0)))?.toFixed(2) || '0.00',
      total_amount_wo_vat:
        (
          (report?.total_amount || report?.net_with_vat || (parseFloat(report?.total_gross_amount || 0) - parseFloat(report?.total_discount || 0))) -
          (parseFloat(report?.patient_vat || 0) + parseFloat(report?.company_vat || 0))
        )?.toFixed(2) || '0.00',
      total_net_amount:
        parseFloat(
          (report?.total_gross_amount || 0) -
          (report?.total_discount || 0)
        )?.toFixed(2) || '0.00',
      patient_name: report?.patient?.full_name || '-',
      group: {
        patient: {
          share: (report?.patient_share || 0).toFixed(2) || '0.00',
          vat: (report?.patient_vat || 0).toFixed(2) || '0.00',
          total:
            (
              parseFloat(report?.patient_share || 0) +
              parseFloat(report?.patient_vat || 0)
            )?.toFixed(2) || '0.00',
        },
        company: {
          name: report?.company?.name || '-',
          share: report?.company_share.toFixed(2) || '0.00',
          vat: report?.company_vat.toFixed(2) || '0.00',
          total:
            (
              parseFloat(report?.company_share) +
              parseFloat(report?.company_vat)
            )?.toFixed(2) || '0.00',
        },
      },
    }))
  )

  const grouped = {}
  flatReports?.forEach(report => {
    const key = report?.created_by || 'Unknown'
    if (!grouped[key]) grouped[key] = []
    grouped[key].push(report)
  })

  const result = []
  const pdf = []
  Object.entries(grouped)?.forEach(([userId, reports]) => {
    const created_by = reports?.[0]?.staff_info?.user?.fullname
      ? `${reports?.[0]?.staff_info?.user?.fullname} (${reports?.[0]?.created_by})`
      : reports?.[0]?.created_by

    result.push({
      created_by,
      isGroupHeader: true,
    })

    result.push(...reports)

    const totalVat = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.patient_vat) + parseFloat(r.company_vat) || 0,
      0
    )

    const totalGrossAmount = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.total_gross_amount) ||
        // + parseFloat(r.total_discount) +
        // parseFloat(r.patient_vat) +
        // parseFloat(r.company_vat) +
        // parseFloat(r?.total_discount)
        0,
      0
    )

    const totalDiscount = reports.reduce(
      (sum, r) => sum + parseFloat(r.total_discount) || 0,
      0
    )

    const totalAmountWithVat = reports.reduce(
      (sum, r) => sum + parseFloat(r.total_amount) || 0,
      0
    )
    const totalAmountWithoutVat = reports.reduce(
      (sum, r) =>
        sum +
        parseFloat(r.total_amount) -
        (parseFloat(r.patient_vat) + parseFloat(r.company_vat)) || 0,
      0
    )

    const totalNetAmount = reports.reduce(
      (sum, r) => sum + parseFloat(r.total_gross_amount) || 0,
      0
    )

    const totalPatientShare = reports.reduce(
      (sum, r) => sum + parseFloat(r.patient_share) || 0,
      0
    )

    const totalPatientVat = reports.reduce(
      (sum, r) => sum + parseFloat(r.patient_vat) || 0,
      0
    )

    const totalPatientTotal = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.patient_share) + parseFloat(r.patient_vat) || 0,
      0
    )

    const totalCompanyShare = reports.reduce(
      (sum, r) => sum + parseFloat(r.company_share) || 0,
      0
    )

    const totalCompanyVat = reports.reduce(
      (sum, r) => sum + parseFloat(r.company_vat) || 0,
      0
    )

    const totalCompanyTotal = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.company_share + parseFloat(r.company_vat) || 0),
      0
    )

    const separator = {
      separator: true,
      user_id: created_by,
      total_vat: totalVat.toFixed(2),
      total_gross_amount: totalGrossAmount.toFixed(2),
      total_discount: totalDiscount.toFixed(2),
      total_amount_w_vat: totalAmountWithVat.toFixed(2),
      total_amount_wo_vat: totalAmountWithoutVat.toFixed(2),
      total_net_amount: (totalNetAmount - totalDiscount)?.toFixed(
        2
      ),
      group: {
        patient: {
          share: totalPatientShare.toFixed(2),
          vat: totalPatientVat.toFixed(2),
          total: totalPatientTotal.toFixed(2),
        },
        company: {
          share: totalCompanyShare.toFixed(2),
          vat: totalCompanyVat.toFixed(2),
          total: totalCompanyTotal.toFixed(2),
        },
      },
    }

    result.push(separator)

    pdf.push({
      header: { key: 'User ID', value: reports?.[0]?.created_by },
      children: reports,
      footer: {
        key: `Subtotal for ${created_by}`,
        value: separator,
      },
    })
  })

  return { result, pdf }
}

export function reducedFinancialReports(data) {
  if (!data) return []

  const flatReports = data?.flatMap(group =>
    group?.reports?.map(report => ({
      ...report,
      total_vat:
        (report?.patient_vat + report?.company_vat)?.toFixed(2) || '0.00',
      total_gross_amount: report?.total_gross_amount?.toFixed(2) || '0.00',
      total_discount: report?.total_discount?.toFixed(2) || '0.00',
      total_amount_w_vat: (report?.total_amount || report?.net_with_vat || (parseFloat(report?.total_gross_amount || 0) - parseFloat(report?.total_discount || 0)))?.toFixed(2) || '0.00',
      total_amount_wo_vat:
        (
          (report?.total_amount || report?.net_with_vat || (parseFloat(report?.total_gross_amount || 0) - parseFloat(report?.total_discount || 0))) -
          (parseFloat(report?.patient_vat || 0) + parseFloat(report?.company_vat || 0))
        )?.toFixed(2) || '0.00',
      total_net_amount:
        parseFloat(
          (report?.total_gross_amount || 0) -
          (report?.total_discount || 0)
        )?.toFixed(2) || '0.00',
      patient_name: report?.patient?.full_name || '-',
      group: {
        patient: {
          share: (report?.patient_share || 0)?.toFixed(2) || '0.00',
          vat: (report?.patient_vat || 0)?.toFixed(2) || '0.00',
          total:
            (
              parseFloat(report?.patient_share || 0) +
              parseFloat(report?.patient_vat || 0)
            )?.toFixed(2) || '0.00',
        },
        company: {
          name: report?.company?.name || '-',
          share: (report?.company_share || 0)?.toFixed(2) || '0.00',
          vat: (report?.company_vat || 0)?.toFixed(2) || '0.00',
          total:
            (
              parseFloat(report?.company_share) +
              parseFloat(report?.company_vat)
            )?.toFixed(2) || '0.00',
        },
      },
      staff_info: group.staff_info,
    }))
  )

  const grouped = {}
  flatReports?.forEach(report => {
    const key = report?.created_by || 'Unknown'
    if (!grouped[key]) grouped[key] = []
    grouped[key].push(report)
  })

  const result = []
  const pdf = []
  Object?.entries(grouped)?.forEach(([userId, reports]) => {
    const created_by = reports?.[0]?.staff_info?.user?.fullname
      ? `${reports?.[0]?.staff_info?.user?.fullname} (${reports?.[0]?.created_by})`
      : reports?.[0]?.created_by

    result.push({
      created_by,
      isGroupHeader: true,
    })

    // result.push(...reports)

    const totalVat = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.patient_vat) + parseFloat(r.company_vat) || 0,
      0
    )

    const totalGrossAmount = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.total_gross_amount) ||
        // + parseFloat(r.total_discount) +
        // parseFloat(r.patient_vat) +
        // parseFloat(r.company_vat) +
        // parseFloat(r?.total_discount)
        0,
      0
    )

    const totalDiscount = reports.reduce(
      (sum, r) => sum + parseFloat(r.total_discount) || 0,
      0
    )

    const totalAmountWithVat = reports.reduce(
      (sum, r) => sum + parseFloat(r.total_amount) || 0,
      0
    )
    const totalAmountWithoutVat = reports.reduce(
      (sum, r) =>
        sum +
        parseFloat(r.total_amount) -
        (parseFloat(r.patient_vat) + parseFloat(r.company_vat)) || 0,
      0
    )

    const totalNetAmount = reports.reduce(
      (sum, r) => sum + parseFloat(r.total_gross_amount) || 0,
      0
    )

    const totalPatientShare = reports.reduce(
      (sum, r) => sum + parseFloat(r.patient_share) || 0,
      0
    )

    const totalPatientVat = reports.reduce(
      (sum, r) => sum + parseFloat(r.patient_vat) || 0,
      0
    )

    const totalPatientTotal = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.patient_share) + parseFloat(r.patient_vat) || 0,
      0
    )

    const totalCompanyShare = reports.reduce(
      (sum, r) => sum + parseFloat(r.company_share) || 0,
      0
    )

    const totalCompanyVat = reports.reduce(
      (sum, r) => sum + parseFloat(r.company_vat) || 0,
      0
    )

    const totalCompanyTotal = reports.reduce(
      (sum, r) =>
        sum + parseFloat(r.company_share + parseFloat(r.company_vat) || 0),
      0
    )

    const separator = {
      separator: true,
      user_id: created_by,
      total_vat: totalVat?.toFixed(2),
      total_gross_amount: totalGrossAmount?.toFixed(2),
      total_discount: totalDiscount?.toFixed(2),
      total_amount_w_vat: totalAmountWithVat?.toFixed(2),
      total_amount_wo_vat: totalAmountWithoutVat?.toFixed(2),
      total_net_amount: (totalNetAmount - totalDiscount)?.toFixed(
        2
      ),
      group: {
        patient: {
          share: totalPatientShare?.toFixed(2),
          vat: totalPatientVat?.toFixed(2),
          total: totalPatientTotal?.toFixed(2),
        },
        company: {
          share: totalCompanyShare?.toFixed(2),
          vat: totalCompanyVat?.toFixed(2),
          total: totalCompanyTotal?.toFixed(2),
        },
      },
    }

    result.push(separator)

    pdf.push({
      header: { key: 'User ID', value: reports?.[0]?.created_by },
      children: reports,
      footer: {
        key: `Subtotal for ${created_by}`,
        value: separator,
      },
    })
  })

  const gross = result.reduce((sum, r) => {
    if (r.separator)
      sum = {
        grand: true,
        total_vat: (
          parseFloat(sum?.total_vat || 0) + parseFloat(r.total_vat)
        )?.toFixed(2),
        total_gross_amount: (
          parseFloat(sum?.total_gross_amount || 0) +
          parseFloat(r.total_gross_amount)
        )?.toFixed(2),
        total_discount: (
          parseFloat(sum?.total_discount || 0) + parseFloat(r.total_discount)
        )?.toFixed(2),
        total_amount_w_vat: (
          parseFloat(sum?.total_amount_w_vat || 0) +
          parseFloat(r.total_amount_w_vat)
        )?.toFixed(2),
        total_amount_wo_vat: (
          parseFloat(sum?.total_amount_wo_vat || 0) +
          parseFloat(r.total_amount_wo_vat)
        )?.toFixed(2),
        total_net_amount: (
          parseFloat(sum?.total_net_amount || 0) +
          parseFloat(r.total_net_amount)
        )?.toFixed(2),
        group: {
          patient: {
            share: (
              parseFloat(sum?.group?.patient?.share || 0) +
              parseFloat(r.group.patient.share)
            )?.toFixed(2),
            vat: (
              parseFloat(sum?.group?.patient?.vat || 0) +
              parseFloat(r.group.patient.vat)
            )?.toFixed(2),
            total: (
              parseFloat(sum?.group?.patient?.total || 0) +
              parseFloat(r.group.patient.total)
            )?.toFixed(2),
          },
          company: {
            share: (
              parseFloat(sum?.group?.company?.share || 0) +
              parseFloat(r.group.company.share)
            )?.toFixed(2),
            vat: (
              parseFloat(sum?.group?.company?.vat || 0) +
              parseFloat(r.group.company.vat)
            )?.toFixed(2),
            total: (
              parseFloat(sum?.group?.company?.total || 0) +
              parseFloat(r.group.company.total)
            )?.toFixed(2),
          },
        },
      }

    return sum
  }, 0)

  result.push({
    nt: true,
  })
  result.push({
    grand: true,
    gross,
  })

  pdf.push({
    footer: { key: 'Net Total', value: gross },
    children: null,
  })

  return { result, pdf }
}

export function calculateSum(data) {
  if (!data) return []

  const result = [...data]

  const gross = result.reduce(
    (sum, r) => ({
      label: 'Total',
      cash_total: (r.cash_total || 0) + sum.cash_total,
      card_total: (r.card_total || 0) + sum.card_total,
      bank_total: (r.bank_total || 0) + sum.bank_total,
      cheque_total: (r.cheque_total || 0) + sum.cheque_total,
      patient_vat_total: (r.patient_vat_total || 0) + sum.patient_vat_total,
      multi_total: (r.multi_total || 0) + sum.multi_total,
      overall_total: (r.overall_total || 0) + sum.overall_total,
      patient_share_total: (r.patient_share_total || 0) + sum.patient_share_total,
    }),
    {
      label: 'Total',
      cash_total: 0,
      card_total: 0,
      bank_total: 0,
      cheque_total: 0,
      patient_vat_total: 0,
      multi_total: 0,
      overall_total: 0,
      patient_share_total: 0,
    }
  )

  result.push({
    grand: true,
    ...gross,
  })

  return result
}

export function transformResult(data, keyPath = []) {
  if (!data || !Array.isArray(data)) return []

  // Helper to get nested value safely
  const getNestedValue = (obj, path) => {
    return path.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      obj
    )
  }

  const toNumber = value => Number(value) || 0
  const formatAmount = value => toNumber(value).toFixed(2)
  const getTotalPatients = row =>
    toNumber(
      row?.total_patients ??
      row?.total_patient ??
      row?.totalPatients ??
      row?.TotalPatients ??
      row?.patients ??
      row?.patient_count
    )

  const grouped = data?.map(report => {
    const value = getNestedValue(report, keyPath)
    const patientShareTotal = toNumber(report?.patient_share_total)
    const patientVatTotal = toNumber(report?.patient_vat_total)
    const companyShareTotal = toNumber(report?.company_share_total)
    const companyVatTotal = toNumber(report?.company_vat_total)

    return {
      ...report,
      name: value,
      patient_share_total: formatAmount(patientShareTotal),
      patient_vat_total: formatAmount(patientVatTotal),
      company_share_total: formatAmount(companyShareTotal),
      company_vat_total: formatAmount(companyVatTotal),
      total_discount: formatAmount(report?.total_discount),
      cash_total: formatAmount(report?.cash_total),
      card_total: formatAmount(report?.card_total),
      bank_total: formatAmount(report?.bank_total),
      cheque_total: formatAmount(report?.cheque_total),
      multi_total: formatAmount(report?.multi_total),
      deposit_total: formatAmount(report?.deposit_total),
      overall_total: formatAmount(report?.overall_total),
      total_patients: getTotalPatients(report),
      total_vat: formatAmount(patientVatTotal + companyVatTotal),
      patient_total: formatAmount(patientShareTotal + patientVatTotal),
      company_total: formatAmount(companyShareTotal + companyVatTotal),
    }
  })

  if (!grouped.length) return []

  let gross = grouped?.reduce((row, next) => ({
    total_patients:
      getTotalPatients(row) + getTotalPatients(next),
    patient_share_total: (
      parseFloat(row?.patient_share_total || 0) +
      parseFloat(next?.patient_share_total || 0)
    )?.toFixed(2),
    patient_vat_total: (
      parseFloat(row?.patient_vat_total || 0) +
      parseFloat(next?.patient_vat_total || 0)
    )?.toFixed(2),
    patient_total: (
      parseFloat(row?.patient_total || 0) + parseFloat(next?.patient_total || 0)
    )?.toFixed(2),
    company_share_total: (
      parseFloat(row?.company_share_total || 0) +
      parseFloat(next?.company_share_total || 0)
    )?.toFixed(2),
    company_vat_total: (
      parseFloat(row?.company_vat_total || 0) +
      parseFloat(next?.company_vat_total || 0)
    )?.toFixed(2),
    company_total: (
      parseFloat(row?.company_total || 0) + parseFloat(next?.company_total || 0)
    )?.toFixed(2),
    total_discount: (
      parseFloat(row?.total_discount || 0) +
      parseFloat(next?.total_discount || 0)
    )?.toFixed(2),
    total_vat: (
      parseFloat(row?.total_vat || 0) + parseFloat(next?.total_vat || 0)
    )?.toFixed(2),
    cash_total: (
      parseFloat(row?.cash_total || 0) + parseFloat(next?.cash_total || 0)
    )?.toFixed(2),
    card_total: (
      parseFloat(row?.card_total || 0) + parseFloat(next?.card_total || 0)
    )?.toFixed(2),
    bank_total: (
      parseFloat(row?.bank_total || 0) + parseFloat(next?.bank_total || 0)
    )?.toFixed(2),
    cheque_total: (
      parseFloat(row?.cheque_total || 0) + parseFloat(next?.cheque_total || 0)
    )?.toFixed(2),
    multi_total: (
      parseFloat(row?.multi_total || 0) + parseFloat(next?.multi_total || 0)
    )?.toFixed(2),
    deposit_total: (
      parseFloat(row?.deposit_total || 0) + parseFloat(next?.deposit_total || 0)
    )?.toFixed(2),
    overall_total: (
      parseFloat(row?.overall_total || 0) + parseFloat(next?.overall_total || 0)
    )?.toFixed(2),
  }))

  gross = { ...gross, gross: true, name: 'Total' }

  const result = [...grouped, gross]

  return result
}

export function groupInsurancePayers(data) {
  if (!data || !Array.isArray(data)) return []

  const payerGroups = {}

  data.forEach(report => {
    report?.Invoices?.forEach(invoice => {
      const payer = invoice.PayerName || 'Unknown'
      const insurance = invoice?.Patient?.insurance_plans?.[0] || {}
      const policyNumber = invoice?.Patient?.selected_plan?.policy_number || 'N/A'
      const membership = insurance?.member_card_id || 'N/A'

      if (!payerGroups[payer]) {
        payerGroups[payer] = {
          PayerName: payer,
          policies: {},
          totals: {
            Gross: 0,
            Discount: 0,
            Net: 0,
            PatientShare: 0,
            PayorNet: 0,
            PayorVAT: 0,
            PayorShare: 0,
            ClaimTotal: 0,
          },
        }
      }

      const payerGroup = payerGroups[payer]

      // Initialize policy group within payer if not exists
      if (!payerGroup.policies[policyNumber]) {
        payerGroup.policies[policyNumber] = {
          PolicyNumber: policyNumber,
          invoices: [],
          totals: {
            Gross: 0,
            Discount: 0,
            Net: 0,
            PatientShare: 0,
            PayorNet: 0,
            PayorVAT: 0,
            PayorShare: 0,
            ClaimTotal: 0,
          },
        }
      }

      const policyGroup = payerGroup.policies[policyNumber]

      // Create invoice row
      const invoiceRow = {
        InvoiceDate: invoice.InvoiceDate,
        FileNo: invoice?.Patient?.file_no,
        PatientName: invoice?.Patient?.full_name || 'Unknown',
        documentId: invoice?.Patient?.document_id,
        CashInvoiceNumber: invoice.CashInvoiceNumber || '',
        CorporateInvoiceNumber: invoice.CorporateInvoiceNumber || '',
        GovernmentInvoiceNumber: invoice.GovernmentInvoiceNumber || '',
        InsuranceInvoice: invoice.InsuranceInvoice || '',
        EpisodeNo: invoice.EpisodeNo,
        InvoiceNumber: invoice.InvoiceNumber,
        ClaimID: invoice.ClaimID || '',
        PolicyNumber: policyNumber,
        Membership: membership,
        Physician: invoice.Physician || '',
        Department: invoice?.Department || '',
        ItemCode: invoice.ItemCode || '',
        ItemDescription: invoice.ItemDescription || '',
        AgreedCode: invoice?.AgreedCode || "",
        AgreedDesc: invoice?.AgreedDesc || "",
        Gross: Number(invoice.Gross || 0),
        Discount: Number(invoice.Discount || 0),
        Net: Number(invoice.Net || 0),
        PatientShare: Number(invoice.PatientShare || 0),
        PayorNet: Number(invoice.PayorNet || 0),
        PayorVAT: Number(invoice.PayorVAT || 0),
        PayorShare: Number(invoice.PayorShare || 0),
        ClaimTotal: Number(invoice.ClaimTotal || 0),
        AuthorizationNumber: invoice.AuthorizationNumber || '',
        ClaimStatus: invoice.ClaimStatus || '',
        AttachFlag: invoice.AttachFlag || false,
        PayerName: payer,
      }

      policyGroup.invoices.push(invoiceRow)

      // Accumulate policy totals
      policyGroup.totals.Gross += invoiceRow.Gross
      policyGroup.totals.Discount += invoiceRow.Discount
      policyGroup.totals.Net += invoiceRow.Net
      policyGroup.totals.PatientShare += invoiceRow.PatientShare
      policyGroup.totals.PayorNet += invoiceRow.PayorNet
      policyGroup.totals.PayorVAT += invoiceRow.PayorVAT
      policyGroup.totals.PayorShare += invoiceRow.PayorShare
      policyGroup.totals.ClaimTotal += invoiceRow.ClaimTotal

      // Accumulate payer totals
      payerGroup.totals.Gross += invoiceRow.Gross
      payerGroup.totals.Discount += invoiceRow.Discount
      payerGroup.totals.Net += invoiceRow.Net
      payerGroup.totals.PatientShare += invoiceRow.PatientShare
      payerGroup.totals.PayorNet += invoiceRow.PayorNet
      payerGroup.totals.PayorVAT += invoiceRow.PayorVAT
      payerGroup.totals.PayorShare += invoiceRow.PayorShare
      payerGroup.totals.ClaimTotal += invoiceRow.ClaimTotal
    })
  })

  // Build final output
  const finalOutput = []

  Object.values(payerGroups).forEach(payerGroup => {
    // Add payer header row
    finalOutput.push({
      isPayerHeader: true,
      PayerName: payerGroup.PayerName,
    })

    // Add all policies and their invoices for this payer
    Object.values(payerGroup.policies).forEach(policyGroup => {
      // Only add policy header if policy number is not empty or N/A
      const shouldShowPolicyHeader = policyGroup.PolicyNumber &&
        policyGroup.PolicyNumber !== 'N/A' &&
        policyGroup.PolicyNumber.trim() !== ''

      if (shouldShowPolicyHeader) {
        // Add policy header row
        finalOutput.push({
          isPolicyHeader: true,
          PolicyNumber: policyGroup.PolicyNumber,
          PayerName: payerGroup.PayerName,
        })
      }

      // Add all invoices for this policy
      policyGroup.invoices.forEach(invoice => {
        finalOutput.push({
          ...invoice,
          Gross: invoice.Gross.toFixed(2),
          Discount: invoice.Discount.toFixed(2),
          Net: invoice.Net.toFixed(2),
          PatientShare: invoice.PatientShare.toFixed(2),
          PayorNet: invoice.PayorNet.toFixed(2),
          PayorVAT: invoice.PayorVAT.toFixed(2),
          PayorShare: invoice.PayorShare.toFixed(2),
          ClaimTotal: invoice.ClaimTotal.toFixed(2),
        })
      })

      // Policy total row removed - not needed
    })

    // Add payer total row
    finalOutput.push({
      isPayerTotal: true,
      PayerName: payerGroup.PayerName,
      Gross: payerGroup.totals.Gross.toFixed(2),
      Discount: payerGroup.totals.Discount.toFixed(2),
      Net: payerGroup.totals.Net.toFixed(2),
      PatientShare: payerGroup.totals.PatientShare.toFixed(2),
      PayorNet: payerGroup.totals.PayorNet.toFixed(2),
      PayorVAT: payerGroup.totals.PayorVAT.toFixed(2),
      PayorShare: payerGroup.totals.PayorShare.toFixed(2),
      ClaimTotal: payerGroup.totals.ClaimTotal.toFixed(2),
    })
  })

  // Calculate grand totals
  const grandTotal = Object.values(payerGroups).reduce(
    (acc, payer) => ({
      Gross: acc.Gross + payer.totals.Gross,
      Discount: acc.Discount + payer.totals.Discount,
      Net: acc.Net + payer.totals.Net,
      PatientShare: acc.PatientShare + payer.totals.PatientShare,
      PayorNet: acc.PayorNet + payer.totals.PayorNet,
      PayorVAT: acc.PayorVAT + payer.totals.PayorVAT,
      PayorShare: acc.PayorShare + payer.totals.PayorShare,
      ClaimTotal: acc.ClaimTotal + payer.totals.ClaimTotal,
    }),
    {
      Gross: 0,
      Discount: 0,
      Net: 0,
      PatientShare: 0,
      PayorNet: 0,
      PayorVAT: 0,
      PayorShare: 0,
      ClaimTotal: 0,
    }
  )

  // Add grand total row
  finalOutput.push({
    isGrandTotal: true,
    Gross: grandTotal.Gross.toFixed(2),
    Discount: grandTotal.Discount.toFixed(2),
    Net: grandTotal.Net.toFixed(2),
    PatientShare: grandTotal.PatientShare.toFixed(2),
    PayorNet: grandTotal.PayorNet.toFixed(2),
    PayorVAT: grandTotal.PayorVAT.toFixed(2),
    PayorShare: grandTotal.PayorShare.toFixed(2),
    ClaimTotal: grandTotal.ClaimTotal.toFixed(2),
  })

  return finalOutput
}

export function groupPayers(data) {
  if (!Array.isArray(data)) return []

  const grouped = {}

  data.forEach(row => {
    if (!row) return

    const invoice = row?.Invoices?.[0] || {}

    // Merge invoice + parent row
    const r = { ...invoice, ...row }

    const payer = r.PayerName || 'Unknown'

    if (!grouped[payer]) {
      grouped[payer] = {
        PayerName: payer,
        NumberOfClaims: 0,
        children: [],
        TotalClaim: 0,
        TotalDiscount: 0,
        TotalGross: 0,
        TotalNet: 0,
        TotalPatientShare: 0,
        TotalPayorNet: 0,
        TotalPayorShare: 0,
        TotalPayorVAT: 0,
      }
    }

    const g = grouped[payer]

    // Count how many invoices belong to this claim
    const claimCount = row?.Invoices?.length || 0
    g.NumberOfClaims += claimCount

    // Add NumberOfClaims INTO child row for ag-grid
    r.NumberOfClaims = g.NumberOfClaims

    // Push child row
    g.children.push(r)

      // Sum numeric totals
      ;[
        'TotalClaim',
        'TotalDiscount',
        'TotalGross',
        'TotalNet',
        'TotalPatientShare',
        'TotalPayorNet',
        'TotalPayorShare',
        'TotalPayorVAT',
      ].forEach(key => {
        g[key] += Number(r[key])?.toFixed(2) || 0
      })
  })

  // Flatten rows (header -> children -> total)
  const result = []

  Object.values(grouped).forEach(group => {
    group.children.forEach(child =>
      result.push({
        ...child,
        NumberOfClaims: group.NumberOfClaims, // add to each child row
      })
    )

    result.push({
      isTotal: true,
      NumberOfClaims: group.NumberOfClaims,
      ...group,
    })
  })

  return result
}

export function groupPolicy(data) {
  if (!Array.isArray(data)) return []

  const grouped = {}

  data.forEach(payerGroup => {
    if (!payerGroup || !payerGroup.Invoices) return

    // Process each invoice in the Invoices array
    payerGroup.Invoices.forEach(invoice => {
      const payerName = invoice.PayerName || payerGroup.PayerName || 'Unknown Payer'

      if (!grouped[payerName]) {
        grouped[payerName] = {
          PayerName: payerName,
          PolicyNumber: invoice.PolicyNumber || payerGroup.PolicyNumber,
          NumberOfClaims: 0,
          children: [],
          totals: {
            TotalClaim: 0,
            TotalDiscount: 0,
            TotalGross: 0,
            TotalNet: 0,
            TotalPatientShare: 0,
            TotalPayorNet: 0,
            TotalPayorShare: 0,
            TotalPayorVAT: 0,
          },
        }
      }

      const g = grouped[payerName]

      // Increment claim count
      g.NumberOfClaims += 1

      // Push invoice to children
      g.children.push(invoice)

      // Sum numeric totals
      g.totals.TotalClaim += Number(invoice.ClaimTotal || 0)
      g.totals.TotalDiscount += Number(invoice.Discount || 0)
      g.totals.TotalGross += Number(invoice.Gross || 0)
      g.totals.TotalNet += Number(invoice.Net || 0)
      g.totals.TotalPatientShare += Number(invoice.PatientShare || 0)
      g.totals.TotalPayorNet += Number(invoice.PayorNet || 0)
      g.totals.TotalPayorShare += Number(invoice.PayorShare || 0)
      g.totals.TotalPayorVAT += Number(invoice.PayorVAT || 0)
    })
  })

  const result = []
  const grandTotals = {
    TotalClaim: 0,
    TotalDiscount: 0,
    TotalGross: 0,
    TotalNet: 0,
    TotalPatientShare: 0,
    TotalPayorNet: 0,
    TotalPayorShare: 0,
    TotalPayorVAT: 0,
    NumberOfClaims: 0,
  }

  Object.values(grouped).forEach(group => {
    // Add each invoice as a row
    group.children.forEach(child =>
      result.push({
        ...child,
        NumberOfClaims: group.NumberOfClaims,
      })
    )

    // Add total row for this payer
    result.push({
      isTotal: true,
      PayerName: group.PayerName,
      PolicyNumber: group.PolicyNumber,
      NumberOfClaims: group.NumberOfClaims,
      ...group.totals,
    })

    // Accumulate grand totals
    grandTotals.TotalClaim += group.totals.TotalClaim
    grandTotals.TotalDiscount += group.totals.TotalDiscount
    grandTotals.TotalGross += group.totals.TotalGross
    grandTotals.TotalNet += group.totals.TotalNet
    grandTotals.TotalPatientShare += group.totals.TotalPatientShare
    grandTotals.TotalPayorNet += group.totals.TotalPayorNet
    grandTotals.TotalPayorShare += group.totals.TotalPayorShare
    grandTotals.TotalPayorVAT += group.totals.TotalPayorVAT
    grandTotals.NumberOfClaims += group.NumberOfClaims

    // Add separator
    result.push({
      isSaperator: true,
    })
  })

  // Add grand total row
  if (Object.values(grouped).length > 0) {
    result.push({
      isGrandTotal: true,
      PayerName: 'GRAND TOTAL',
      ...grandTotals,
    })
  }

  return result
}

// Flatten Policy-Payer Data
export function flattenPolicyPayerData(data) {
  if (!data || !Array.isArray(data)) return []

  const result = []

  data.forEach(group => {
    // Add group header
    result.push({
      isGroupHeader: true,
      PayerName: group.PayerName,
      PolicyNumberHolder: group.PolicyNumber || '',
    })

    // Add all invoices under this group
    group.Invoices.forEach(inv => {
      result.push({
        ...inv,
        PolicyNumber: group.PolicyNumber, // ensure policy number is at top level
      })
    })

    // Add total row for the group
    const total = group.Invoices.reduce(
      (acc, inv) => {
        acc.Gross += Number(inv.Gross || 0)
        acc.Discount += Number(inv.Discount || 0)
        acc.Net += Number(inv.Net || 0)
        acc.PatientShare += Number(inv.PatientShare || 0)
        acc.PayorNet += Number(inv.PayorNet || 0)
        acc.PayorVAT += Number(inv.PayorVAT || 0)
        acc.PayorShare += Number(inv.PayorShare || 0)
        acc.ClaimTotal += Number(inv.ClaimTotal || 0)
        return acc
      },
      {
        Gross: 0,
        Discount: 0,
        Net: 0,
        PatientShare: 0,
        PayorNet: 0,
        PayorVAT: 0,
        PayorShare: 0,
        ClaimTotal: 0,
      }
    )

    result.push({
      isTotal: true,
      ...total,
    })
  })

  return result
}
